import React, { ComponentProps, ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '../layout/Box';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Img } from './Img';
import { MediaCover } from './MediaCover';
import defaultAvatar from './resources/defaultAvatar.svg';
import type { BreakpointProp } from '../../utils/styles/breakpoints';

export const AvatarCover = styled(MediaCover).withConfig({ displayName: 'AvatarCover' })`
    border-radius: 50%;
    overflow: hidden;
    user-select: none;
    background-color: var(--background-primary);
`;

interface AvatarProps extends ComponentProps<typeof Box> {
    title?: string;
    src?: string;
    size?: BreakpointProp<number>;
}

export const Avatar = forwardRef((props: AvatarProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { title = '', size = 32, src = defaultAvatar, ...other } = props;

    return (
        <AvatarCover ref={ref} width={size} ratio={1} dataTestId={DataTestId.AVATAR} {...other}>
            <Img src={src} alt={title} key={src} />
        </AvatarCover>
    );
});
